import { xAxis, yAxis, chart } from './chart-data'

export const customChartData = {
  chart: chart(),
  xAxis: xAxis(),
  yAxis: yAxis(),
  colors: ['#6C7B95', '#66CBE0'],
  plotOptions: {
    series: {
      marker: {
        radius: 6
      },
      pointWidth: 16,
      pointPadding: 0,
      groupPadding: 0.3
    },
    column: {
      borderRadiusTopLeft: 16,
      borderRadiusTopRight: 16
    }
  }
}
